import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.forgotPassword(email, window.location.origin);
      setSent(true);
      toast.success(r.message || "Reset link sent");
    } catch {
      toast.error("Could not send reset link — please try again");
    } finally {
      setLoading(false);
    }
  };

  const input =
    "w-full border border-white/15 bg-slate-950 px-4 py-3 text-white outline-none transition-colors duration-200 placeholder:text-slate-500 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500";

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-slate-900 p-6">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-[400px] w-[500px] -translate-x-1/2 rounded-full bg-emerald-500/10 blur-[120px]" />
      <div className="relative w-full max-w-md border border-white/10 bg-slate-950 p-10">
        <div className="mb-8">
          <img src="/logo.png" alt="Ticker Templates" className="h-11 w-auto" />
        </div>
        {sent ? (
          <div data-testid="forgot-sent">
            <div className="mx-auto flex h-14 w-14 items-center justify-center bg-emerald-500 text-slate-900">
              <CheckCircle2 className="h-7 w-7" />
            </div>
            <h1 className="mt-6 font-display text-2xl font-extrabold tracking-tight text-white">Check your inbox</h1>
            <p className="mt-2 text-sm text-slate-400">
              If an account exists for <span className="text-emerald-400">{email}</span>, a password reset link is on
              its way. The link expires in 1 hour.
            </p>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-black uppercase tracking-tight text-white">Reset access</h1>
            <p className="mt-2 text-sm text-slate-400">Enter your admin email and we'll send you a secure reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <label className="mb-1.5 block font-mono text-[10px] uppercase tracking-wider text-slate-500">Email</label>
                <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@tickertemplates.com" className={input} />
              </div>
              <button data-testid="forgot-submit" disabled={loading} className="flex w-full items-center justify-center gap-2 bg-emerald-500 px-6 py-3.5 font-semibold text-slate-900 transition-[background-color] duration-200 hover:bg-emerald-400 disabled:opacity-60">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />}
                {loading ? "Sending..." : "Send reset link"}
              </button>
            </form>
          </>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm text-slate-400 transition-colors duration-200 hover:text-white">
          <ArrowLeft className="h-4 w-4" /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
